@if (routerLink()) {
    <a [routerLink]="routerLink()" [class.active]="isActive()" [attr.data-test]="testId() ?? null">
        @if (icon()) {
            <i [class]="icon()"></i>
        }
        <span>{{ label() }}</span>
    </a>
}
